/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  GetMcpAgentMyToken200
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Gera um JWT MCP para o usuário autenticado. Útil para autenticar nos endpoints MCP. Requer sessão ativa.
 * @summary Obter token MCP do usuário logado
 */
export type getMcpAgentMyTokenResponse200 = {
  data: GetMcpAgentMyToken200
  status: 200
}

export type getMcpAgentMyTokenResponse401 = {
  data: void
  status: 401
}

export type getMcpAgentMyTokenResponseSuccess = (getMcpAgentMyTokenResponse200) & {
  headers: Headers;
};
export type getMcpAgentMyTokenResponseError = (getMcpAgentMyTokenResponse401) & {
  headers: Headers;
};

export type getMcpAgentMyTokenResponse = (getMcpAgentMyTokenResponseSuccess | getMcpAgentMyTokenResponseError)

export const getGetMcpAgentMyTokenUrl = () => {


  

  return `https://api.wedofi.com/mcp-agent/my-token`
}

export const getMcpAgentMyToken = async ( options?: RequestInit): Promise<getMcpAgentMyTokenResponse> => {
  
  return customFetch<getMcpAgentMyTokenResponse>(getGetMcpAgentMyTokenUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

